/**
 * D2C / PTL segmented toggle for the health pages.
 * Emits the CT `shipmentType_list` value: 'B2C' (D2C) or 'PTL'.
 */
import React from 'react'
import {Box, Button} from '@mui/material'
import {FONT} from '../../styles/foundation/typography'
import {PRIMARY_BLUE, BORDER, SUBTLE, WHITE} from '../../styles/foundation/colors'

// CT freightsnapshot keys PTL freight as shipmentType_list=B2B (not 'PTL').
const OPTS = [{v: 'B2C', l: 'D2C'}, {v: 'B2B', l: 'PTL'}]

export default function VerticalToggle({value, onChange}) {
  return (
    <Box sx={{display: 'inline-flex', gap: 0.5, mb: 2, p: 0.5, borderRadius: '10px', border: `1px solid ${BORDER}`, bgcolor: '#f8f9fc'}}>
      {OPTS.map((o) => {
        const active = value === o.v
        return (
          <Button key={o.v} onClick={() => onChange(o.v)} disableElevation size='small' variant={active ? 'contained' : 'text'}
            sx={{
              fontFamily: FONT, textTransform: 'none', borderRadius: '8px', minWidth: 80, fontWeight: 700,
              bgcolor: active ? PRIMARY_BLUE : 'transparent', color: active ? WHITE : SUBTLE,
              '&:hover': {bgcolor: active ? PRIMARY_BLUE : '#eef1f6'},
            }}>
            {o.l}
          </Button>
        )
      })}
    </Box>
  )
}
